import { Button } from '@mui/material';
import React from 'react';
import { capitalizeFirstLetter } from '../../utils/strings';

// The message is sentence-cased unless preserveCase is set, for copy that is
// already written as it should read (e.g. "AI ...").
function Toast({ message, link, preserveCase = false }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        fontFamily: 'var(--font-family-ibm_plex_sans)',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div>{preserveCase ? message : capitalizeFirstLetter(message)}</div>
      {link && (
        <Button
          color="secondary"
          style={{
            color: 'white',
            fontFamily: 'var(--font-family-ibm_plex_sans)',
          }}
          size="small"
          onClick={() => {
            window.location.href = link;
          }}
        >
          View
        </Button>
      )}
    </div>
  );
}

export default Toast;
